export function buildGoodsClickTrackingParams(item = {}, rank = 0, source = 'system') {
  const price = Number(item?.finalPrice)
  const normalizedRank = Number(rank)

  return {
    productId: String(item?.itemId || item?.id || ''),
    productName: String(item?.title || ''),
    price: Number.isFinite(price) ? price : 0,
    rank: Number.isFinite(normalizedRank) ? normalizedRank : 0,
    source: String(source || ''),
    sourcePlatform: String(item?.platform || item?.iconType || ''),
  }
}
